import BaseObject from "../../../base/base_object";
import WalletFallbackHandler from "./handlers/wallet_fallback_handler";
import {FALLBACK_HANDLERS} from './fallback_service_consts';

export default class FallbackHandlerDependenciesFactory extends BaseObject {
    static CLASS = 'FallbackHandlerDependenciesFactory';

    init(params) {
        super.init(params);

        if(!params.serviceFactory) {
            this.throwArgumentExpected('12', 'init', 'serviceFactory');
        }

        this._serviceFactory = params.serviceFactory;
        this._handlerParams = params;
    }

    createHandler(handlerName, params) {
        switch (handlerName) {
            case FALLBACK_HANDLERS.WALLET:
                return WalletFallbackHandler.create(Object.assign({}, {serviceFactory: this._serviceFactory}, this._handlerParams.Wallet));
            default:
                // maybe should throw an Exception here
                return undefined;
        }
    }
}